import React from 'react'

const ContentWrapper = (props) => (
  <div className='content-wrapper' {...props}>
    {props.children}
  </div>
)

export default ContentWrapper
